class popupPickupLista {


    constructor() {
        this.init();
    }

    init() {
        if ($('a[data-pickup-felugro-lista]').length > 0)
        {
            this.initPickupListahandlers();
        }
    }

    initPickupListahandlers() {
        $('a[data-pickup-felugro-lista]').each((i, el) => {
            $(el).on("click", (e) => {
                e.preventDefault();
                this.openMessage(e.target);
            });
        });
    }

    openMessage(el) {
        popupMessageSystem.showWin('');
        $('.pms-message').empty();
        $('<div>').addClass('wait-datas').appendTo($('.pms-message'));

        $.get('/index.php/webshop/pickup_pontok_lista', {r: new Date().getTime()}, function(res){
            if (res != '')
            {
                if (typeof mennyisegitablazat_popup_szoveg != 'undefined')
                {
                    res = res.replace('{popup_szoveg}', base64Decode(mennyisegitablazat_popup_szoveg));
                }
                $('.pms-message').html(res);
            }
        }, 'html');

    }
}

export default popupPickupLista;
